import React from 'react';
import PropTypes from 'prop-types';
import PostComponent from './activity_sources/post';
import CommunityComponent from './activity_sources/community';
import JobPostingComponent from './activity_sources/job_posting';

const ActivitySource = ({ source, creator, community }) => {

  const sourceType = source.__typename;

  const [Component, attrs] = {
    Post: [PostComponent, { post: source }],
    Community: [CommunityComponent, { community: source }],
    JobPosting: [JobPostingComponent, { jobPosting: source }]
  }[sourceType];

  return (
    <div className="activity-source">
      <Component { ...{ creator, community, ...attrs } } />
    </div>
  );
}

ActivitySource.propTypes = {
};

export default ActivitySource;
